<section class="checkout-modal tools-dialog mb-4">
  <div class="close" (click)="closeModal()">
    <i
      class="fa-solid fa-x c-icon-primary c-icon-primary-sm c-icon-round-hover mr-3 mt-4"></i>
  </div>
  <div class="modal-header mb-4"></div>
  <div class="modal-body sanofi-modal-body">
    <section>
      <p>{{message | cxTranslate}}</p>
      <div class="action-btns">
        <button
          aria-label="Cancel"
          class="c-button c-button--secondary"
          (click)="closeModal()">
          {{"common.cancel" | cxTranslate}}
        </button>
        <a
          aria-label="Continue"
          class="c-button c-button--primary"
          href="{{linkUrl}}"
          target="_blank"
          (click)="closeModal()"
          >{{"common.continue" | cxTranslate}}</a
        >
      </div>
    </section>
  </div>
</section>
